import { identity } from 'underscore';

const textAssetMapper = assets =>
  JSON.stringify(assets.map(asset => ({
    text: asset.Asset.Text,
  })));

export const AssetGroup = {
  parent: 'Campaign',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Asset Group',
    },
    Name: {
      'bulk-upload-header': 'Asset Group',
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    BusinessName: {
      'bulk-upload-header': 'Business Name',
    },
    Path1: {
      'bulk-upload-header': 'Path 1',
    },
    Path2: {
      'bulk-upload-header': 'Path 2',
    },
    CallToAction: {
      'bulk-upload-header': 'Call To Action',
    },
    FinalUrls: {
      'bulk-upload-header': 'Final Url',
      'bulk-upload-mapper': function (value) {
        return value.join('; ');
      },
    },
    MobileFinalUrls: {
      'bulk-upload-header': 'Mobile Final Url',
      'bulk-upload-mapper': identity,
    },
    Headlines: {
      'bulk-upload-header': 'Headlines',
      'bulk-upload-mapper': textAssetMapper,
    },
    LongHeadlines: {
      'bulk-upload-header': 'Long Headlines',
      'bulk-upload-mapper': textAssetMapper,
    },
    Descriptions: {
      'bulk-upload-header': 'Descriptions',
      'bulk-upload-mapper': textAssetMapper,
    },
    Images: {
      type: 'string',
    },
    StartDate: {
      'bulk-upload-header': 'Start Date',
    },
    EndDate: {
      'bulk-upload-header': 'End Date',
    },
  },
};
